import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MachineCategory } from '../../../../core/models/entities/machine-category.type';
import { MachineInfoDB } from '../../../../core/interfaces/machine-info.interface';

interface editLocationForm {
  locationName: string;
  categoryId: number;
}

@Component({
  selector: 'modal-edit-location',
  templateUrl: './modal-edit-location.component.html',
  styleUrls: ['./modal-edit-location.component.scss']
})
export class ModalEditLocationComponent implements OnInit {
  @ViewChild('editLocationForm', { static: true }) ngForm: NgForm;

  editLocation: MachineInfoDB;
  initialLocationData: MachineInfoDB;
  categories: MachineCategory[];
  valueChanged: Observable<boolean>;

  ngOnInit(): void {
    this.initialLocationData = {...this.editLocation};

    this.valueChanged = this.ngForm.form.valueChanges.pipe(
      map((form: editLocationForm) => form.locationName !== this.initialLocationData.Title ||
        form.categoryId !== this.initialLocationData.CategoryId
      )
    );
  }
}
